import { Component, Inject, HostListener, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { ENV } from '@app/constants/global.constants';
import { RouteConstants } from '@app/constants/route.constants';
import { AuthenticationService } from '@app/security/authentication.service';
import { Env } from '@app/types/env';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';

// eslint-disable-next-line @typescript-eslint/ban-types
declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public sampleTranslationStr: string = marker('sample.text');
  public count: number = this.getCount();

  constructor(
    @Inject(ENV) private env: Env,
    private meta: Meta,
    private logger: NGXLogger,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthenticationService
  ) {

    if (this.isUserRoleVisualizador()) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const path = event.urlAfterRedirects.split('/').slice(0, 2).join('/');
          gtag('event', 'page_view', {
            page_path: path,
            page_title: path.replace(/^\//, '')
          });
        }
      });
    }
    window.history.pushState = new Proxy(window.history.pushState, {
      apply: (target, thisArg, argArray) => {
        if (window.history.state) {
          window.history.state.fromPopState = false;
        }
        return target.apply(thisArg, argArray);
      }
    });
  }

  @HostListener('window:resize', ['$event']) onResize(event: { target: { innerHeight: number } }) {
    this.setVhProperty();
  }

  @HostListener('window:popstate', ['$event']) onPopState(event: PopStateEvent) {
    if (window.history.state) {
      window.history.state.fromPopState = true;
      window.history.state.isPwa = this.getPWADisplayMode() !== 'browser';
    }
  }

  public getPWADisplayMode(): 'twa' | 'standalone' | 'browser' {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (document.referrer.startsWith('android-app://')) {
      return 'twa';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } else if ((navigator as any).standalone || isStandalone) {
      return 'standalone';
    }
    return 'browser';
  }

  ngOnInit() {
    this.logger.debug('App.component#ngOnInit', this.env.apiBaseUrl);
    this.addBuildInfoMetatag();

    // Sample translation using observable (just in case
    // language JSON is not loaded yet)
    this.translate.get(this.sampleTranslationStr, { count: this.count }).subscribe((txt) => {
      this.logger.debug('subscribed translation =>', txt);
    });

    // Sample instant translation. Be sure to call this
    // after the language JSON is loaded. If you call it like this,
    // (ngOnInit on the app.component) this instant() function could
    // be called BEFORE language .json file has been loaded (because
    // language files are ajax-loaded)
    this.logger.debug('instant translation =>', this.translate.instant(this.sampleTranslationStr, { count: this.count }));

    this.setVhProperty();

    // if (!this.authenticationService.isUserLogged()) {
    //   this.router.navigate([RouteConstants.LOGIN]);
    // }
  }

  public isUserRoleVisualizador(): boolean {
    return this.authService.getUserRole() === 'VISUALITZADOR';
  }

  private setVhProperty(): void {
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    document.documentElement.style.setProperty('--vw', vw + 'px');
  }

  private getCount(): number {
    const MAX_RANDOM_NUMBER = 3;

    return Math.floor(Math.random() * MAX_RANDOM_NUMBER);
  }

  private addBuildInfoMetatag(): void {
    this.logger.info('Adding build version info to <head>:', this.env.appVersion);

    this.meta.updateTag({
      name: 'version',
      content: `${this.env.appVersion}`
    });
  }
}
